import { render } from "./permissions-users-list.vue?vue&type=template&id=1500af84&lang=pug"
import script from "./permissions-users-list.vue?vue&type=script&lang=js"
export * from "./permissions-users-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__